import api from 'utils/api';

export const checkUserExistAPI = (data) => api.post('/user/exist', data);
export const sendOtpAPI = (data) => api.post('/otp/generate', data);
export const validateOtpAPI = (data) => api.post('/otp/validate', data);
export const signUpAPI = (data) => api.post('/user', data);
